<template>
  <div
    ref="coinRef"
    class="hero-coin absolute z-[1]"
    :class="[className]"
    :style="{
      transform: `translate(${mouseOffsetX}px, ${scrollOffset + mouseOffsetY}px)`,
      transition: 'transform 0.1s ease-out'
    }"
  >
    <img
      :src="src"
      :alt="alt"
      class="w-full h-auto"
      loading="lazy"
    />
  </div>
</template>

<script setup lang="ts">
import { useParallax } from '~/composables/useParallax'

const props = defineProps<{
  src: string
  alt: string
  className?: string
  scrollIntensity?: number
  mouseIntensity?: number
}>()

const coinRef = ref<HTMLElement | null>(null)
const { scrollOffset, mouseOffsetX, mouseOffsetY, setElement } = useParallax({
  scrollSpeed: props.scrollIntensity || -0.15,
  mouseIntensity: props.mouseIntensity || 0.03,
  enableMouse: true
})

onMounted(() => {
  if (coinRef.value) {
    setElement(coinRef.value)
  }
})
</script> 